import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import VisitorService from "../../services/visitor.service";

const initialState = {
  visitorCount: 0,
  loading: false,
  error: null,
};

export const addVisitor = createAsyncThunk(
  "visitor/addVisitor",
  async (_, thunkAPI) => {
    try {
      const response = await VisitorService.addVisitor();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const getVisitorCount = createAsyncThunk(
  "visitor/getVisitorCount",
  async (_, thunkAPI) => {
    try {
      const response = await VisitorService.getVisitor();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const visitorSlice = createSlice({
  name: "visitor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Add Visitor
      .addCase(addVisitor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addVisitor.fulfilled, (state, action) => {
        state.loading = false;
        state.visitorCount = action.payload.count;
      })
      .addCase(addVisitor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get Visitor Count
      .addCase(getVisitorCount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVisitorCount.fulfilled, (state, action) => {
        state.loading = false;
        state.visitorCount = action.payload.count;
      })
      .addCase(getVisitorCount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default visitorSlice.reducer;